// Laatst gekozen beschikbare tijd, bewaard als minuten-string (of '' voor "geen limiet").
import { useCallback, useState } from 'react';
import { TIME_BUDGET_OPTIONS, type TimeBudget } from '../domain/suggest';
import { KEYS } from '../storage/keys';
import { getString, setString } from '../storage/localStore';

export function parseTimeBudget(raw: string | null): TimeBudget {
  const n = Number((raw ?? '').trim());
  const opt = TIME_BUDGET_OPTIONS.find((o) => o.value === n);
  return opt ? opt.value : null;
}

export function usePersistedTimeBudget(): [TimeBudget, (b: TimeBudget) => void] {
  const [budget, setBudget] = useState<TimeBudget>(() => parseTimeBudget(getString(KEYS.timeBudget)));
  const set = useCallback((b: TimeBudget) => {
    setBudget(b);
    setString(KEYS.timeBudget, b === null ? '' : String(b));
  }, []);
  return [budget, set];
}
